import React from "react";

function TeamInformation({ teamResult, savedData, currentId, onFootballManagerIdChange }) {
  const currentSavedData = savedData.find(data => data.id === currentId) || {};

  return (
    <div className="mb-4">
      <h2 className="text-xl font-bold mb-2">Team Information</h2>
      <p><strong>Name:</strong> {teamResult.name}</p>
      <p><strong>Short Name:</strong> {teamResult.shortName}</p>
      <p><strong>Country:</strong> {teamResult.country?.name}</p>
      <p><strong>Code:</strong> {teamResult.code}</p>
      <p><strong>Division:</strong> {teamResult.mainTournament?.competitionName}</p>
      {teamResult.foundationDate && (
        <p><strong>Foundation Date:</strong> {teamResult.foundationDate}</p>
      )}
      {teamResult.colors && (
        <p><strong>Colors:</strong> {teamResult.colors}</p>
      )}
      <div className="mt-4">
        <label htmlFor="footballManagerId" className="block text-sm font-medium text-gray-700">
          Football Manager ID
        </label>
        <input
          type="text"
          id="footballManagerId"
          name="footballManagerId"
          value={currentSavedData.footballManagerId || ""}
          onChange={onFootballManagerIdChange}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        />
      </div>
    </div>
  );
}

export default TeamInformation;
